import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/:itemId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    subscriptionId: string;
    itemId: string;
}
const mutationFn = ({ itemId, subscriptionId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { itemId, subscriptionId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteSubscriptionItem };
